/**
 *
 * @Description:
 *
 * Modal Dialog component
 *
 */

'use strict'

import React, {Component} from 'react'
import PropTypes from 'prop-types'
import ReactModal from 'react-modal'
import classNames from 'classnames'

const MODAL_CONTAINER_CLASS = 'nmc-modal-container'
const MODAL_OVERLAY_CLASS = 'nmc-modal-overlay'
const MODAL_BODY_CLASS = 'nmc-modal-body'
const MODAL_FOOTER_CLASS = 'nmc-modal-footer'
const MODAL_TITLE_CLASS = 'nmc-modal-title'
const MODAL_CLOSE_CLASS = 'nmc-modal-close'

export default class Modal extends Component {

  static propTypes = {
    onClose: PropTypes.func,
    isOpen: PropTypes.bool,
    shouldCloseOnOverlayClick: PropTypes.bool
  }

  // default prop types
  static defaultProps = {
    shouldCloseOnOverlayClick: true
  }

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  extendChildrenWithProps = () => {
    // we extend children of first level with onClose CB to handle hide dialog,if needed
    return React.Children.map(this.props.children,
      (child) => React.cloneElement(child, {
        onClose: this.handleClose
      })
    )
  }

  render () {
    // extend children of first level with onClose CB to handle hide modal, if needed
    let extendedProps = Object.assign({}, this.props, {
      children: this.extendChildrenWithProps()
    })

    return (
      <ReactModal onRequestClose={this.handleClose}
        className={MODAL_CONTAINER_CLASS}
        overlayClassName={MODAL_OVERLAY_CLASS}
        contentLabel='NMC-Modal'
        {...extendedProps} />
    )
  }
}

Modal.Body = class extends Component {
  static propTypes = {
    children: PropTypes.node
  }

  render () {
    return (
      <div className={MODAL_BODY_CLASS}>{this.props.children}</div>
    )
  }
}

Modal.Footer = class extends Component {
  static propTypes = {
    children: PropTypes.node
  }

  render () {
    return (
      <div className={MODAL_FOOTER_CLASS}>{this.props.children}</div>
    )
  }
}

Modal.Header = class extends Component {
  static propTypes = {
    children: PropTypes.node,
    showCloseButton: PropTypes.bool,
    title: PropTypes.string
  }

  // default prop types
  static defaultProps = {
    showCloseButton: true
  }

  handleClick = () => {
    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  render () {
    let closeButton = this.props.showCloseButton ? (
      <div className='nmc-modal-close-btn-holder' onClick={this.handleClick}>
        <span className={MODAL_CLOSE_CLASS} />
      </div>)
      : null
    let title = this.props.title ? <div className={MODAL_TITLE_CLASS}>{this.props.title}</div> : null
    let customTitle = (!this.props.title) ? <div className={MODAL_TITLE_CLASS}>{this.props.children}</div> : null
    let onlyCloseButton = this.props.showCloseButton && !this.props.title && !this.props.children

    const classes = {
      'nmc-modal-header-with-title': title,
      'nmc-modal-header-custom-title': !title,
      'nmc-modal-header-only-close-button': onlyCloseButton
    }

    return (
      <div className={classNames(classes)}>
        {title}
        {customTitle}
        {closeButton}
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Modal/Modal.js